import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

function formatErr(detail) {
  if (!detail) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success(`Welcome back, ${user.name}!`);
      const from = loc.state?.from || (user.role === "admin" ? "/admin" : user.role === "vendor" ? "/vendor" : "/");
      nav(from);
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16">
      <div className="rounded-2xl border border-[#E2E8E5] bg-white p-8">
        <div className="text-xs uppercase tracking-[0.2em] text-[#14A085]">Welcome back</div>
        <h1 className="font-display text-3xl text-[#0F3D2E] mt-1">Sign in to Florvanta</h1>
        <form onSubmit={submit} className="mt-6 space-y-4" data-testid="login-form">
          <div>
            <label className="text-xs text-[#3B5249]">Email</label>
            <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1" data-testid="login-email" />
          </div>
          <div>
            <label className="text-xs text-[#3B5249]">Password</label>
            <Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1" data-testid="login-password" />
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-[#0F3D2E] hover:bg-[#14A085] text-white rounded-full" data-testid="login-submit">
            {loading ? "Signing in…" : "Sign In"}
          </Button>
        </form>
        <p className="mt-6 text-sm text-[#3B5249]">
          No account?{" "}
          <Link to="/register" className="text-[#14A085] hover:underline" data-testid="link-register">Create one</Link>
        </p>
        <div className="mt-6 rounded-lg bg-[#E8F5F2] p-3 text-xs text-[#0F3D2E]">
          <div className="font-medium">Demo credentials</div>
          <div>Admin: admin@florvanta.co.in / Admin@123</div>
        </div>
      </div>
    </div>
  );
}
